import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import { ISpec, ISpecDetailResponse, ISpecOptionsDetail, IBuySpecPost } from '../models';
import { IDropdownResponse, IResponse } from '../models/util';

const baseUrl = '/api/specs';

export const getSpecs = async (filters?: {
  search?: string;
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  neighborhoodId?: string;
  lotNumber?: string;
  planId?: string | number;
  territoryId?: string | number;
  isForViewSpecs?: boolean;
}): Promise<IResponse<ISpec[]>> => {
  try {
    const response = await axios.get(baseUrl, {
      params: filters
    });
    return response.data;
  } catch (error) {
    logError(error, 'getSpecs failed');
    return Promise.reject(error);
  }
};

export const getSpecOptions = async (id: string): Promise<ISpecOptionsDetail> => {
  try {
    const response = await axios.get(`${baseUrl}/${id}/options`);
    return response.data;
  } catch (error) {
    logError(error, 'getSpecOptions failed');
    return Promise.reject(error);
  }
};
export const getSpecSelectedOptionsById = async (filters?: {
  buildId?: string;
  neighborhoodId?: string | number;
  lotNumber?: string | number;
}): Promise<ISpecDetailResponse> => {
  try {
    const response = await axios.get(`${baseUrl}/selected-options`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return response.data;
  } catch (error) {
    logError(error, 'getSpecSelectedOptionsById failed');
    return Promise.reject(error);
  }
};

export const finishSpec = async (buildId: string | number) => {
  try {
    const { data } = await axios.put(`${baseUrl}/${buildId}/finish`);
    return data;
  } catch (error) {
    logError({ error, payload: { buildId } }, 'finishSpec failed');
    return Promise.reject(error?.response?.data);
  }
};

export const buySpec = async (buildId: string | number, post: IBuySpecPost) => {
  try {
    const { data } = await axios.post(`${baseUrl}/${buildId}/buy`, post);
    return data;
  } catch (error) {
    logError({ error, payload: { post } }, 'buySpec failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSpecCompletionLevels = async (): Promise<IDropdownResponse[]> => {
  try {
    const response = await axios.get(`${baseUrl}/completion-levels`);
    return response.data;
  } catch (error) {
    logError(error, 'getSpecCompletionLevels failed');
    return Promise.reject(error);
  }
};

export const getSpecPriceSheet = async () => {
  try {
    return await axios.get(`${baseUrl}/price-guide`, {
      responseType: 'blob'
    });
  } catch (error) {
    logError(error, 'getSpecPriceSheet failed');
    return Promise.reject(error?.response?.data);
  }
};
